import './assets/css/main.css';

import Icon from '@/components/ui/Icon.vue';
import Toaster from '@/components/ui/toast/Toaster.vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import VueFeather from 'vue-feather';
import App from './App.vue';
import PageHeaderVue from './components/ui/PageHeader.vue';
import router from './router';
import { useAuthStore } from './stores/authStore';

const app = createApp(App)

app.component(VueFeather.name, VueFeather);
app.component('PageHeader', PageHeaderVue);
app.component('Toaster', Toaster);
app.component('Icon', Icon);

app.use(createPinia())
const authStore = useAuthStore();
authStore.initAuth().then(()=>{
app.use(router)
app.mount('#app')
})

